module.exports = __webpack_public_path__ + "static/project-e7d8c1960c437bd82682356bcb4160d4.jpg";